export interface WorkItemTemplate {
  templateId: string;
  name: string;
  description?: string | null;
  workItemKind: "fix" | "feature" | "ui";
  deliverableTemplatePath?: string;
}

interface ListResponse {
  ok: boolean;
  templates?: WorkItemTemplate[];
  error?: string;
}

function handleError(response: Response, payload: { error?: string }, fallback: string): never {
  const message = payload?.error ?? `${fallback} (status ${response.status})`;
  throw new Error(message);
}

export async function fetchWorkItemTemplates(): Promise<WorkItemTemplate[]> {
  const response = await fetch("/api/work-item-templates");
  const payload = (await response.json()) as ListResponse;

  if (!response.ok || payload.ok === false) {
    handleError(response, payload, "Failed to fetch work item templates");
  }

  return payload.templates ?? [];
}
